<script
    src="../../../../../../../AppData/Local/Temp/Rar$DRa14036.14120/src/app/helper/alertTimer/alert-timer.service.ts"
></script>
<template>
  <!-- The Modal -->
  <div
      id="rolesModal"
      class="modal"
  >
    <div class="modal-dialog">
      <div class="modal-content">
        <!-- Modal Header -->
        <div class="modal-header">
          <button
              type="button"
              class="close"
              data-dismiss="modal"
          >
            &times;
          </button>
        </div>
        <!-- Modal body -->
        <div class="">
          <!--Start-->
          <b-card-code
              title="Assign Roles"
          >
            <!-- form -->
            <validation-observer ref="simpleRules">
              <b-form>
                <b-row>
                  <b-col md="12">
                    <b-form-group>
                      <label for="first_name">Roles</label>
                      <validation-provider
                          #default="{ errors }"
                          name="roles"
                          rules="required"
                      >
                        <v-select
                            name="roles"
                            v-model="assignedRoles.roles"
                            class="parent-service"
                            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                            :options="roles"
                            :reduce="name => name.id"
                            label="name"
                            multiple
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                </b-row>

                <!-- Modal footer -->
                <div class="modal-footer">
                  <button
                      type="button"
                      class="btn btn-primary"
                      @click.prevent="validationForm"
                  >
                    Submit
                  </button>
                </div>
              </b-form>
            </validation-observer>

            <template #code>
              {{ codeMultiple }}
            </template>
          </b-card-code>
          <!--End-->
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import BCardCode from '@core/components/b-card-code'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BFormInput, BFormGroup, BForm, BRow, BCol, BFormTextarea,

} from 'bootstrap-vue'
import {
  required, email, confirmed, password,
} from '@validations'
import vSelect from 'vue-select'
import vue2Dropzone from 'vue2-dropzone'
import { codeMultiple, codeBasic } from './code'
import FormTextAreaDefault from '../../../shared/form-textarea/FormTextAreaDefault.vue'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import clientService from '@/services/clientService'
import ToastificationContent from '@core/components/toastification/ToastificationContent'
import adminService from '../../../services/adminService'
import representativesService from '@/services/representativesService'

export default {
  components: {
    BCardCode,
    ValidationProvider,
    ValidationObserver,

    BFormInput,
    BFormGroup,
    BForm,
    BRow,
    BCol,
    BFormTextarea,
    FormTextAreaDefault,
    vSelect,
    vueDropzone: vue2Dropzone,
  },
  props: ['admin'],
  data() {
    return {
      roles: [],
      adminId: '',
      assignedRoles: {roles: []},
      required,
      password,
      email,
      confirmed,
      codeMultiple,
      codeBasic,
    }
  },
  mounted() {
    this.getRoles()
    this.$watch(() => this.admin, admin => {
      this.adminId = admin
      console.log(';lllll', this.adminId)
      this.getRolesByAdmin()

    })

  },
  methods: {
    getRoles() {
      this.loading = true
      adminService.index().then(response => {
         this.roles = response.data.data
          })
    },
    getRolesByAdmin() {
      adminService.rolesByAdmin(this.adminId).then(response => {
        this.assignedRoles.roles = response.data && response.data.data.length >= 0  ? response.data.data : []
      })
    },
    validationForm() {
      this.$refs.simpleRules.validate()
          .then(success => {
            if (success) {
              adminService.AssignRoles(this.adminId, this.assignedRoles.roles).then(response => {
                this.$emit('refresh', 'true')
                $('#rolesModal').modal('hide')
                if (response && response.status === 200) {
                  this.$toast({
                    component: ToastificationContent,
                    position: 'top-right',
                    props: {
                      title: 'Success',
                      icon: 'CheckIcon',
                      variant: 'success',
                      text: 'Roles Is Saved Successfully !',
                    },
                  })
                }
                this.loading = false
                console.log('testing')
              })
            }
          }).catch(function (error) {
        console.log('Show error notification!', error)
        $('#rolesModal').modal('hide')
        this.$toast({
          component: ToastificationContent,
          position: 'top-right',
          props: {
            title: 'Success',
            icon: 'CheckIcon',
            variant: 'Error',
            text: 'Error !',
          },
        })
        return Promise.reject(error)
      })
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';

label {
  font-weight: bold;
}
</style>
<style>
#rolesModal svg{
  filter: invert(69%) sepia(14%) saturate(4763%) hue-rotate(3deg) brightness(100%) contrast(43%)!important;
}
</style>
